export default __webpack_public_path__ + "static/media/powered_by_realtorca.b879e856.svg";